import { render } from "./BeneficiarySearch.vue?vue&type=template&id=199079fe"
import script from "./BeneficiarySearch.vue?vue&type=script&lang=js"
export * from "./BeneficiarySearch.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__